import { localStorageAccessor } from "igfd-commons/src/app-index";

// A module that gets the current user's user id.

// local storage key for anonymous user id
const ANONYMOUS_USER_ID = "anonymousUserId";

export const getAnonymousUserId: () => string = () => {
  const newId = generateRandomId();
  const [getLocalValue, setLocalValue] = localStorageAccessor(
    ANONYMOUS_USER_ID,
    newId
  );

  // if the new id is being returned, it means the user has not been assigned an id yet
  // we set the new id to the local storage
  const anonymousUserId = getLocalValue();
  if (anonymousUserId === newId) {
    setLocalValue(newId);
  }

  return anonymousUserId;
};

const generateRandomId = () => {
  return Math.random().toString(36).substring(2);
};
